import { useRef } from "react";
import { generateUuid } from "../../generate-uuid/generateUuid.js";

/**
 * Helper to generate ID-s for UI purpose. Uses UUID v4.
 */
export const useId = () => {
  const ref = useRef<string>();
  if (ref.current === undefined) {
    ref.current = generateUuid();
  }
  return ref.current;
};
